import BaseResource from './index'

export default class LegislativeResource extends BaseResource {
    static endpoint = '/oasis/restv3/legislativeTypes'
}
